<template>  
  <div class="home">
    <banner-search></banner-search>
    <div class="content-holder">
      <!-- <recommendation v-if ="isLoggedIn"></recommendation> -->
      <trendingCourses v-if="showTrendingCard"></trendingCourses>
      <div>
        <libraryCards v-if ="showLibraryCard"></libraryCards>
      </div>
      <div>
        <newVideoCards v-if ="showNewVideoCard"></newVideoCards>
      </div>
      <infinite-loading @infinite="infiniteHandler" spinner="waveDots" ref="infiniteLoader">
        <span slot ='no-results'></span>
        <span slot ='no-more'></span>
      </infinite-loading>
    </div>
 </div>
</template>
<script>
import InfiniteLoading from 'vue-infinite-loading'
import { EventBus, gAnalysis } from '@/main.js'
import bannerSearch from './bannerSearch'
import courseCards from './courseCards'
import libraryCards from './libraryCards'
import recommendation from './recommendation'
import newVideoCards from './newVideoCards'
import trendingCourses from './trendingCourses'
export default {
  name: 'home',
  components: {
    recommendation,
    InfiniteLoading,
    bannerSearch,
    newVideoCards,
    courseCards,
    libraryCards,
    trendingCourses
  },
  data () {
    return {
      showTrendingCard: false,
      showLibraryCard: false,
      showNewVideoCard: false,
      globalState: ''
    }
  },
  methods: {
    handleScroll () {
      if (this.showTrendingCard && !this.showLibraryCard) {
        setTimeout(() => {
          this.showLibraryCard = true
          if (this.$refs.infiniteLoader !== undefined) {
            // this.$refs.infiniteLoader.$emit('$InfiniteLoading:complete')
            this.globalState.complete()
          }
        }, 100)
      } else if (this.showTrendingCard && this.showLibraryCard) {
        setTimeout(() => {
          this.showNewVideoCard = true
          if (this.$refs.infiniteLoader !== undefined) {
            // this.$refs.infiniteLoader.$emit('$InfiniteLoading:complete')
            this.globalState.complete()
          }
        }, 100)
      }
    },
    infiniteHandler ($state) {
      this.globalState = $state
      setTimeout(() => {
        this.showTrendingCard = true
        // this.showLibraryCard = true
        $state.loaded()
      }, 100)
    },
    checkTokenValidity () {
      var home = this
      var token = window.MKCLAPI.getToken()
      if (token !== undefined && token !== null) {
        window.MKCLAPI.isTokenValid(token).then(function () {
          // token is valid
        }).catch(function () {
          home.$store.dispatch('clearUserData')
          window.MKCLAPI.removeToken()
        })
      }
    }
  },
  computed: {
    isLoggedIn () {
      return this.$store.getters.getIsLoggedIn
    }
  },
  mounted () {
    gAnalysis()
    this.checkTokenValidity()
    EventBus.$emit('showNav', true)
    this.$store.dispatch('changeSearchType', 'all').then(response => { }, error => {
      console.log('error in changing search type', error)
    })
  },
  created () {
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/home/home.vue?e88178ca